/* eslint @typescript-eslint/camelcase: 0 */

import {HcmRouteConfig} from "@/router";
import EasyRoot from "@/components/pages/easy/index.vue";
import TradeContractHome from "@/components/pages/easy/TradeContractHome.vue";
import TradeContract from "@/components/pages/easy/TradeContract.vue";
import TradeResult from "@/components/pages/easy/TradeResult.vue";
import SystemHome from "@/components/pages/easy/SystemHome.vue";
import Implementation from "@/components/pages/easy/Implementation.vue";
import Dictionary from "@/components/pages/easy/Dictionary.vue";
import DictionaryManagement from "@/components/pages/easy/DictionaryManagement.vue";
import DictionaryCreation from "@/components/pages/easy/DictionaryCreation.vue";
import Terminal from "@/components/pages/easy/Terminal.vue";
import HelpHome from "@/components/pages/easy/HelpHome.vue";

const routes: HcmRouteConfig[] = [

  // 1st level /////////////////////////////////////////////////////////////////////////////////////////////////////////

  // かんたんモードホーム
  {
    path: '/easy',
    name: '/easy',
    component: EasyRoot,
    meta: {
      label: 'かんたんモード',
      parent: 'Home',
      hideDrawer: true
    }
  },

  // 2nd level /////////////////////////////////////////////////////////////////////////////////////////////////////////

  // かんたんモードホーム → データ取引を行う
  {
    path: '/easy/tradeContractHome',
    name: '/easy/tradeContractHome',
    component: TradeContractHome,
    meta: {
      label: 'データ取引を行う',
      parent: '/easy',
      permissions: ['contract'],
    }
  },

  // かんたんモードホーム → システムの管理を行う
  {
    path: '/easy/systemHome',
    name: '/easy/systemHome',
    component: SystemHome,
    meta: {
      label: 'システムの管理を行う',
      parent: '/easy'
    }
  },

  // かんたんモードホーム → ヘルプ
  {
    path: '/easy/helpHome',
    name: '/easy/helpHome',
    component: HelpHome,
    meta: {
      label: 'ヘルプ',
      parent: '/easy'
    }
  },

  // 3rd level /////////////////////////////////////////////////////////////////////////////////////////////////////////

  /******************************************************************
   * かんたんモードホーム → データ取引を行う
   * ****************************************************************/

  // かんたんモードホーム → データ取引を行う → 契約を作成する
  {
    path: '/easy/tradeContractHome/tradeContract',
    name: '/easy/tradeContractHome/tradeContract',
    component: TradeContract,
    meta: {
      label: '契約を作成する',
      parent: '/easy/tradeContractHome',
      permissions: ['contract'],
    }
  },

  // かんたんモードホーム → データ取引を行う → 取引実績を見る
  {
    path: '/easy/tradeContractHome/tradeResult',
    name: '/easy/tradeContractHome/tradeResult',
    component: TradeResult,
    meta: {
      label: '取引実績を見る',
      parent: '/easy/tradeContractHome',
      permissions: ['contract'],
    }
  },

  /******************************************************************
   * かんたんモードホーム → システムの管理を行う
   * ****************************************************************/

  // かんたんモードホーム → システムの管理を行う → 実装を管理する
  {
    path: '/easy/systemHome/implementation',
    name: '/easy/systemHome/implementation',
    component: Implementation,
    meta: {
      label: '実装を管理する',
      parent: '/easy/systemHome',
      permissions: ['implementation'],
    }
  },

  // かんたんモードホーム → システムの管理を行う → 辞書を管理する
  {
    path: '/easy/systemHome/dictionary',
    name: '/easy/systemHome/dictionary',
    component: Dictionary,
    meta: {
      label: '辞書を管理する',
      parent: '/easy/systemHome',
      permissions: ['dictionary'],
    }
  },

  // かんたんモードホーム → システムの管理を行う → サイトを管理する
  {
    path: '/easy/systemHome/terminal',
    name: '/easy/systemHome/terminal',
    component: Terminal,
    meta: {
      label: 'サイトを管理する',
      parent: '/easy/systemHome',
      permissions: ['implementation'],
    }
  },


  // 4th level /////////////////////////////////////////////////////////////////////////////////////////////////////////

  /******************************************************************
   * かんたんモードホーム → システムの管理を行う → 辞書を管理する
   * ****************************************************************/

  // かんたんモードホーム → システムの管理を行う → 辞書を管理する → 辞書の管理を行う
  {
    path: '/easy/systemHome/dictionary/management',
    name: '/easy/systemHome/dictionary/management',
    component: DictionaryManagement,
    meta: {
      label: '辞書の管理を行う',
      parent: '/easy/systemHome/dictionary',
      permissions: ['dictionary'],
    }
  },

  // かんたんモードホーム → システムの管理を行う → 辞書を管理する → 辞書を新たに作成する
  {
    path: '/easy/systemHome/dictionary/creation',
    name: '/easy/systemHome/dictionary/creation',
    component: DictionaryCreation,
    meta: {
      label: '辞書を新たに作成する',
      parent: '/easy/systemHome/dictionary',
      permissions: ['dictionary'],
    }
  },
  

];

export default routes;
